import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';

const PANEL_MAX_HEIGHT_DEFAULT = 600;
const PANEL_BOTTOM_MARGIN = 7;
const PANEL_TOP_MARGIN = 7;

const useDimensions = (searchInputRef) => {
  const [panelMaxHeight, setPanelMaxHeight] = useState(
    PANEL_MAX_HEIGHT_DEFAULT,
  );

  const dimensionsCalculation = useCallback(() => {
    let nextPanelMaxHeight = PANEL_MAX_HEIGHT_DEFAULT;
    if (searchInputRef.current) {
      const { bottom } = searchInputRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const maxHeight =
        windowHeight - bottom - PANEL_BOTTOM_MARGIN - PANEL_TOP_MARGIN;
      if (maxHeight < PANEL_MAX_HEIGHT_DEFAULT) {
        nextPanelMaxHeight = maxHeight;
      }
    }
    setPanelMaxHeight(nextPanelMaxHeight);
  }, [searchInputRef]);
  const debouncedDimensionsCalculation = useMemo(
    () => debounce(dimensionsCalculation, 300),
    [dimensionsCalculation],
  );

  useEffect(() => {
    debouncedDimensionsCalculation();
    window.addEventListener('resize', debouncedDimensionsCalculation);
    return () => {
      window.removeEventListener('resize', debouncedDimensionsCalculation);
    };
  }, [debouncedDimensionsCalculation]);

  return { panelMaxHeight };
};

export default useDimensions;
